const setColors = (risk, theme, scoreType = 'RISK', t = null) => {
  let color;
  let background;
  let text;

  let isNum = /^[+-]?\d*\.?\d+(?:[eE][+-]?\d+)?$/.test(risk);

  // Handle WELLNESS scores (0-100 scale with reversed color logic)
  if (scoreType === 'WELLNESS' && isNum) {
    const score = parseFloat(risk);
    if (score >= 81) {
      // 81-100: Green (same as RISK level 1)
      color = theme.palette.colors.green400;
      background = theme.palette.colors.bgGreen;
      text = `${Math.round(score)}% ${t ? t('WELLNESS') : 'WELLNESS'}`;
    } else if (score >= 61) {
      // 61-80: Yellow (same as RISK level 2)
      color = theme.palette.colors.yellow100;
      background = theme.palette.colors.bgYellow;
      text = `${Math.round(score)}% ${t ? t('WELLNESS') : 'WELLNESS'}`;
    } else if (score >= 41) {
      // 41-60: Orange/Brown (same as RISK level 3)
      color = theme.palette.colors.brown;
      background = theme.palette.colors.bgOrange;
      text = `${Math.round(score)}% ${t ? t('WELLNESS') : 'WELLNESS'}`;
    } else if (score >= 21) {
      // 21-40: Light Red (same as RISK level 4)
      color = theme.palette.colors.red100;
      background = theme.palette.colors.bgRed100;
      text = `${Math.round(score)}% ${t ? t('WELLNESS') : 'WELLNESS'}`;
    } else if (score > 0) {
      // 1-20: Dark Red (same as RISK level 5)
      color = theme.palette.colors.red200;
      background = theme.palette.colors.bgRed200;
      text = `${Math.round(score)}% ${t ? t('WELLNESS') : 'WELLNESS'}`;
    } else {
      // 0: Neutral (same as RISK level 0)
      color = theme.palette.colors.black100;
      background = theme.palette.colors.gray200;
      text = `0% ${t ? t('WELLNESS') : 'WELLNESS'}`;
    }
    return { color, background, text };
  }

  // Original RISK logic (0-5 scale) - unchanged

  if (isNum) {
    switch (Math.floor(risk)) {
      case 1: {
        color = theme.palette.colors.green400;
        background = theme.palette.colors.bgGreen;
        text = t ? t('VERY LOW RISK') : 'VERY LOW RISK';
        break;
      }
      case 2: {
        color = theme.palette.colors.yellow100;
        background = theme.palette.colors.bgYellow;
        text = t ? t('LOW RISK') : 'LOW RISK';
        break;
      }
      case 3: {
        color = theme.palette.colors.brown;
        background = theme.palette.colors.bgOrange;
        text = t ? t('MEDIUM RISK') : 'MEDIUM RISK';
        break;
      }
      case 4: {
        color = theme.palette.colors.red100;
        background = theme.palette.colors.bgRed100;
        text = t ? t('HIGH RISK') : 'HIGH RISK';
        break;
      }
      case 5: {
        color = theme.palette.colors.red200;
        background = theme.palette.colors.bgRed200;
        text = t ? t('VERY HIGH RISK') : 'VERY HIGH RISK';
        break;
      }
      case 0: {
        color = theme.palette.colors.black100;
        background = theme.palette.colors.gray200;
        text = t ? t('NO RISK') : 'NO RISK';
        break;
      }
      default: {
        color = theme.palette.colors.black100;
        background = theme.palette.colors.gray200;
        text = scoreType === 'WELLNESS' ? `0% ${t ? t('WELLNESS') : 'WELLNESS'}` : (t ? t('NO RISK') : 'NO RISK');
        break;
      }
    }
  } else {
    switch (risk?.charAt(0).toUpperCase() + risk?.slice(1).toLowerCase()) {
      case 'Minimum':
        color = theme.palette.colors.green400;
        break;
      case 'Low':
        color = theme.palette.colors.yellow100;
        break;
      case 'Medium':
        color = theme.palette.colors.orange200;
        break;
      case 'High':
        color = theme.palette.colors.red100;
        break;
      case 'Critical':
        color = theme.palette.colors.red200;
        break;
      default:
        color = theme.palette.colors.black100;
    }
  }

  return { color, background, text };
};

export default setColors;
